import { render, staticRenderFns } from "./SoOnOrderDetail.vue?vue&type=template&id=1d53bcc0"
import script from "./SoOnOrderDetail.vue?vue&type=script&lang=js"
export * from "./SoOnOrderDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports